// import Cookies from 'js-cookie'

const meteoTokenKey = 'meteo-Token'
const ScreenTokenKey = 'sdshipping-screen-Token'
const headerKey = 'header-key'
const userNameKey = 'user-Name'

export function getMeteoToken () {
  return sessionStorage.getItem(meteoTokenKey)
}

export function setMeteoToken (token) {
  return sessionStorage.setItem(meteoTokenKey, token)
}

export function removeMeteoToken () {
  return sessionStorage.removeItem(meteoTokenKey)
}

export function getScreenToken() {
  return sessionStorage.getItem(ScreenTokenKey)
}

export function setScreenToken(token) {
  return sessionStorage.setItem(ScreenTokenKey, token)
}

export function removeScreenToken() {
  return sessionStorage.removeItem(ScreenTokenKey)
}

export function getKey() {
  return sessionStorage.getItem(headerKey)
}

export function setKey(key) {
  return sessionStorage.setItem(headerKey, key)
}

export function removeKey() {
  return sessionStorage.removeItem(headerKey)
}

export function getUserName() {
  return sessionStorage.getItem(userNameKey)
}

export function setUserName(value) {
  return sessionStorage.setItem(userNameKey, value)
}

export function removeUserName() {
  return sessionStorage.removeItem(userNameKey)
}